import { FEATURED_OFFERS_LOGO_VIEW, FEATURED_OFFERS_LOGO_SWIPED_TRIGGER, VIEW_ALL_STORES_VIEW } from './types';

export const triggerFeaturedOffersLogoIsViewed = (merchants) => ({
  type: FEATURED_OFFERS_LOGO_VIEW,
  merchants,
});

export const triggerFeaturedOffersLogoIsSwiped = (slideIndex, storeCount) => ({
  type: FEATURED_OFFERS_LOGO_SWIPED_TRIGGER,
  slideIndex,
  storeCount,
});

export const triggerViewAllStoresIsViewed = () => ({
  type: VIEW_ALL_STORES_VIEW,
});
